import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { toggle_popup } from "redux/actions/modal";
import { get_info, translate } from "redux/actions/main";
import { useBackgroundAssets } from "helper";

export const Congrats = () => {
  const dispatch = useDispatch();
  const { spin_prize } = useSelector((state) => state.main);
  const { param } = useSelector((state) => state.auth);
  const lightBg = useBackgroundAssets("light");
  const t = (key) => dispatch(translate(key));

  return (
    <div className="congrats-modal">
      <h4 className="congrats-msg">
        {spin_prize?.is_grandprize
          ? t("FFIP_GOT_JACKPOT").replace("{prize}", spin_prize?.item_name)
          : t("FFIP_HAVENT_GOT_JACKPOT").replace(
              "{prize}",
              param?.lang === "ar"
                ? `${spin_prize?.item_num} ${spin_prize?.item_name}`
                : `${spin_prize?.item_num}x ${spin_prize?.item_name}`
            )}
      </h4>
      <div className="prize" style={spin_prize?.is_grandprize ? lightBg : {}}>
        <img src={spin_prize?.item_img} alt="" />
      </div>
      <button
        className="btn btn-close uppercase"
        style={useBackgroundAssets("btn_spin_to_get")}
        onClick={() => {
          dispatch(toggle_popup(false, ""));
          dispatch(get_info());

          if (spin_prize?.form_link) {
            window.open(spin_prize.form_link);
          }
        }}
      >
        {t(spin_prize?.form_link ? "FFIP_FILL_FORM" : "FFIP_BTN_CONTINUE")}
      </button>
    </div>
  );
};
